export const SCHEMA = [
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Monday",
    slots: [],
  },
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Tuesday",
    slots: [],
  },
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Wednesday",
    slots: [],
  },
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Thursday",
    slots: [],
  },
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Friday",
    slots: [],
  },
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Saturday",
    slots: [],
  },
  {
    elementConfig: {
      type: "checkbox",
    },
    elementType: "input",
    name: "Sunday",
    slots: [],
  },
];
